<template>
    <div class="container">
        <div class="home-banner">
            <swiper :options="bannerOption">
                <swiper-slide><img src="@/assets/home/banner.jpg" alt=""></swiper-slide>
            </swiper>
            <!-- <div class="swiper-pagination"></div>
            <div class="swiper-icon swiper-right"></div>
            <div class="swiper-icon swiper-left"></div> -->
            <!-- <video ref="videoPlayer" src="../../../src/assets/homeVideo.mp4" style="width: 100%;" autoplay muted  loop playsinline @ended="restartVideo"></video> -->
        </div>
        <img src="@/assets/home/dataTop.jpg" style="width: 100%;margin: 0;gap: 0;" alt="">
        <!--加盟数据-->
        <div class="join-infs-wrap">
            <ul id="count-id" class="join-infs">
                <li class="join-inf icon-store b-right">
                    <div class="join-inf-num"><ICountUp
                                    :delay="delay"
                                    :endVal="countObj.storeNum || 0"
                                    :options="options"/>+</div>
                    <div class="join-inf-text">现有门店数</div>
                </li>
                <li class="join-inf icon-add b-right">
                    <div class="join-inf-num">
                                <ICountUp
                                    :delay="delay"
                                    :endVal="countObj.skunum || 0"
                                    :options="options"/>+</div>
                    <div class="join-inf-text">总SKU</div>
                </li>
                <li class="join-inf icon-location b-right">
                    <div class="join-inf-num"><ICountUp
                                    :delay="delay"
                                    :endVal="countObj.memberNum || 0"
                                    :options="optionsNum"
                                    />亿+</div>
                    <div class="join-inf-text">现有会员数</div>
                </li>
                <li class="join-inf icon-user">
                    <div class="join-inf-num"><ICountUp
                                    :delay="delay"
                                    :endVal="countObj.customerNum || 0"
                                    :options="pointOption"/>亿+</div>
                    <div class="join-inf-text">年接待顾客人次</div>
                </li>
            </ul>
            <div class="join-infs-date">*数据来源：截至2025年9月3日，据鸣鸣很忙集团门店经营系统统计</div>
        </div>
        <img src="@/assets/home/dataBottom.jpg" style="width: 100%;display: block;" alt="">
        <div class="bigBc">

        <!--赵一鸣零食 IP-->
        <div style="width: 100%; position: relative;">
                <img 
                    src="@/assets/home/homeBig.png" 
                    style="width: 100%; height: auto; display: block;" 
                    alt=""
                />
        </div>
        <!-- <div id="ip-content" class="ip-content"> -->
            <!-- <div class="logo-ip"><img src="@/assets/home/logo-ip.png" alt=""></div>
            <p class="ip-text">打造让消费者喜爱，让加盟商赚钱的零食品牌</p>
            <div class="ip-sit-bg"><img src="@/assets/home/img_ip_sit_bg.png" alt=""></div>
            <div class="ip-sit"><img src="@/assets/home/img_ip_sit.png" alt=""></div> -->
          
        <!-- </div> -->
        <!--发展历程-->
        <div class="process-content" ref="fzlc">
            <div class="process-title" style="color: #590D0D;font-size: 98px;font-weight: bold;">
                发展历程
                <!-- <img src="@/assets/home/title_develop.png" alt=""> -->
            </div>
            <div id="process-el" class="process-timeline">
                <ul class="timeline-left">
                    <li class="timeline-item" v-for="(item,index) in leftTimeData" :key="index">
                        <div class="timeline-time left-time t-right">{{ item.date }}</div>
                        <div class="timeline-desc t-right" v-html="item.desc" ></div>
                        <div class="timeline-img al-end"><img :src="item.imgUrl" alt=""></div>
                    </li>
                </ul>
                <div class="timeline-center"></div>
                <ul class="timeline-right">
                    <li class="timeline-item" v-for="(item,index) in rightTimeData" :key="index">
                        <div class="timeline-time right-time">{{ item.date }}</div>
                        <div class="timeline-desc" v-html="item.desc"></div>
                        <div class="timeline-img"><img :src="item.imgUrl" alt=""></div>
                    </li>
                </ul>
            </div>
            <!--形象图片-->
            <!-- <div id="ip-id" class="ip-fly"><img src="@/assets/home/img_ip_fly.png" alt=""></div> -->
        </div>
        <!--新修改 企业使命&价值观-->
        <div class="qy-wrap" ref="smjzg">
            <div class="qy-top">
                <div class="qy-left">
                    <p class="qy-title">{{ qyList[currActiveQy].title }}<span class="qy-title-sign">{{ qyList[currActiveQy].flag }}</span></p>
                    <ul :class="{'qy-content-wrap':true,'symbol-1':currActiveQy === 1}">
                        <li class="qy-content" v-for="(item,index) in qyList[currActiveQy].content" :key="index">{{ item }}</li>
                    </ul>
                </div>
                <div class="qy-right"><img :src="qyList[currActiveQy].imgUrl" alt=""></div>
            </div>
            <div class="qy-list-wrap">
                <ul class="qy-list">
                    <li :class="{'qy-item':true, 'active-item':currActiveQy === index}" v-for="(item,index) in qyList" :key="index" @click="changeQy(index)">
                        <i class="qy-flag"><img src="@/assets/icon/TabICON.png" alt=""></i>
                        <span class="qy-index">{{ item.flag }}</span>
                        <span class="qy-text">{{ item.title }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <!--链接部分-->
        <div class="link-wrap" ref="dhcsr">
            <!-- <div class="link-title-img"><img src="@/assets/home/word3.png" alt=""></div> -->
            <div class="link-others">
                <!-- <div :class="{'link-img':true,active:activeLink==='Dialogue'}">
                    <img src="@/assets/home/dialog.jpg" alt="">
                    <div class="link-title-wrap pr-link">
                        <div class="link-img-title" title="赵一鸣零食创始人赵定：平价零食像七八年前的茶饮，比赛刚刚开始｜36专访">赵一鸣零食创始人赵定：平价零食像七八年前的茶饮，比赛刚刚开始｜36专访</div>
                        <span class="link-img-btn" @click="goDialog('https://mp.weixin.qq.com/s/TtQI_JPE4Av-cGu-tjCLQw?from=industrynews&version=4.1.20.6006&platform=win')">查看详情</span>
                    </div>
                </div> -->
                <div :class="{'link-img':true,active:['News','Stories','Trends'].includes(activeLink)}">
                    <div>
                        <swiper ref="linkImgRef" :options="linkOptions" :key="activeLink">
                            <swiper-slide v-for="(item,index) in linkDatas[activeLink]" :key="item.id">
                                <div @click="openWin(item)">
                                    <img :src="item.newsPic" alt="">
                                    <div class="link-title-wrap">
                                        <span class="link-img-title" :title="item.newsTitle">{{ item.newsTitle }}</span>
                                        <span v-if="item.newsLink" class="link-img-btn" @click.stop="goDialog(item.newsLink)">查看详情</span>
                                    </div>
                                    <i v-show="item.newsPic && item.newsVideo" class="icon-play"><img src="@/assets/icon/icon_player.png" alt=""></i>
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>
                <!-- <div :class="{'link-img':true,active:activeLink==='Trends'}">
                    <img src="@/assets/home/brand.jpg" alt="">
                    <div class="link-title-wrap pr-link">
                        <div class="link-img-title" title="赵一鸣零食做好食品安全再添新举措，与国际权威检测机构签约在穗举行">赵一鸣零食做好食品安全再添新举措，与国际权威检测机构签约在穗举行</div>
                        <span class="link-img-btn" @click="goDialog('https://www.iheima.com/article-362048.html')">查看详情</span>
                    </div>
                </div> -->
                <ul class="link-top">
                    <!-- <li :class="{'link-items':true, active:activeLink==='Dialogue'}" @click="toggleLink('Dialogue')">
                        <div class="link-title">对话创始人</div>
                    </li> -->
                    <li :class="{'link-items':true, active:activeLink==='News'}" @click="toggleLink('News')">
                        <div class="link-title">新闻资讯</div>
                        <!-- <div class="link-title-en">News</div> -->
                    </li>
                    <li :class="{'link-items':true, active:activeLink==='Stories'}" @click="toggleLink('Stories')">
                        <div class="link-title">加盟商故事</div>
                        <!-- <div class="link-title-en">Stories</div> -->
                    </li>
                    <li :class="{'link-items':true, active:activeLink==='Trends'}" @click="toggleLink('Trends')">
                        <div class="link-title">品牌动向</div>
                        <!-- <div class="link-title-en">Trends</div> -->
                    </li>
                </ul>
            </div>
        </div>

        <div v-if="dialogVisible" class="fixed-video-wrap" @click="closeDialog">
            <div class="fixed-video-container" @click.stop="">
                <video-player class="vjs-custom-skin" :options="playerOptions"></video-player>
            </div>
        </div>
    </div>

    </div>
</template>
<script>
    import ICountUp from 'vue-countup-v2';
    import "video.js/dist/video-js.css";
    import "vue-video-player/src/custom-theme.css";
    export default{
        components: {ICountUp},
        data(){
            return {
                rightTimeData:[
                    
                    {date:'2019.01',desc:'赵一鸣零食品牌成立首家直营店开业',imgUrl:require('@/assets/home/process-08.png')},
                    {date:'2023.11',desc:'零食很忙与赵一鸣零食战略合并为“鸣鸣很忙”集团',imgUrl:require('@/assets/home/process-19.png')},
                    {date:'2024.03',desc:'举办万物生长伙伴大会<br/>首个万人盛事',imgUrl:require('@/assets/home/process-22.png')},
                    {date:'2025.02',desc:'引领量贩零食3.0  2025鸣鸣很忙省钱发布会',imgUrl:require('@/assets/home/process-28.jpg')},
                    {date:'2025.09',desc:'鸣鸣很忙集团门店总数突破20000家',imgUrl:require('@/assets/home/process-26.jpg')},

                    // {date:'2022',desc:'02月，品牌形象升级，江西门店总数84家<br>12月，赵一鸣全国门店总数突破700家，芜湖、南昌、赣州3大仓配中心投入使用',imgUrl:require('@/assets/home/process-22.jpg')},
                ],
                leftTimeData:[
                    {date:'2020.10',desc:'全面开放加盟',imgUrl:require('@/assets/home/Rectangle-10.png')},
                    // {date:'2018',desc:'至2018年直营门店超过20家 ，单店面积超过120㎡',imgUrl:require('@/assets/home/process-20.jpg')},
                    // {date:'2023.12',desc:'获得好想你、盐津铺子控股共同投资10.5亿',imgUrl:require('@/assets/home/Rectangle-11.png')},
                    
                    {date:'2024.07',desc:'双品牌官宣<br/>代言人周杰伦',imgUrl:require('@/assets/home/Rectangle-12.png')},
                    {date:'2024.09',desc:'全新升级<br/>赵一鸣省钱超市',imgUrl:require('@/assets/home/chaoshi1.png')},
                    {date:'2025.07',desc:'零食很忙携手赵一鸣零食  举办2025零食音乐节',imgUrl:require('@/assets/home/process-27.jpg')},


                    // {date:'2023.12',desc:'获得好想你、盐津铺子控股共同投资10.5亿',imgUrl:require('@/assets/home/Rectangle-11.png')},

                    // {date:'2023',desc:'02月，完成A轮融资1.5亿元，全国门店突破1000家<br>10月，建成9大仓储物流中心，19万㎡仓储空间<br>全国门店突破2500家<br>12月，获得好想你和盐津铺子控股合计10.5亿元投资',imgUrl:require('@/assets/home/process-23.jpg')},

                ],
                qyList:[
                    {flag:'01',title:'企业使命',imgUrl:require('@/assets/home/qysm3.png'),content:['帮消费者省钱','帮加盟商赚钱','帮员工更值钱']},
                    // {flag:'02',title:'企业价值观',imgUrl:require('@/assets/home/qysm4.jpg'),content:['分享一鸣','信任共鸣','感恩和鸣','创造争鸣']},
                    {flag:'02',title:'企业理念',imgUrl:require('@/assets/home/qysm5.png'),content:['食品安全大于一切，不入我口，不进我店；','消费者大于加盟商，加盟商大于公司组织；','只赚合理利润，把更多的实惠让给顾客。']},
                    {flag:'03',title:'廉洁申明',imgUrl:require('@/assets/home/lianjie.png'),content:['一“严”为定 欢迎一切合作，谢绝一切公关送礼搞关系，不如没关系；','渎职与贪腐，都在断后路；','相互守廉洁，合作更直接；各司其职务，合作更长久。']},
                ],
                currActiveQy:0,
                activeLink:'News',
                countObj:{
                    successRate:95,
                    secondRate:65,
                    storeNum:2200,
                    customerNum:1.5,
                    stuffNum:3000,
                    skunum: 3300,
                    memberNum:2700
                },
                delay: 0,
                options: {
                    startVal: 0,
                    duration: 1,
                    useEasing: false,
                    useGrouping: false,
                    separator: ',',
                    decimal: '.',
                    immediate:false,
                    // decimalPlaces:1
                    
                },
                optionsNum:{
                    startVal: 0,
                    duration: 1,
                    useEasing: false,
                    useGrouping: false,
                    separator: ',',
                    decimal: '.',
                    immediate:false,
                    decimalPlaces:1
                },
                pointOption:{
                    startVal: 0,
                    duration: 1.5,
                    useEasing: false,
                    useGrouping: false,
                    separator: ',',
                    decimal: '.',
                    immediate:false,
                    // decimalPlaces:0
                },
                bannerOption:{
                    effect: 'slide',
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    loop:false,
                    autoplay:{
                        delay:3000,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: '.swiper-left',
                        prevEl: '.swiper-right',
                    },
                    pagination: {
                        clickable:true,
                        el: '.swiper-pagination'
                    }
                },
                linkDatas:{
                    // Dialogue:[
                    //     {id:1,img:require('@/assets/home/dialog.jpg'),title:'赵一鸣零食做好食品安全再添新举措，与国际权威检测机构签约在穗举行',link:'https://mp.weixin.qq.com/s/KjBq4uVSoT6lB3mUAESEKA'},
                    // ],
                    News:[
                        {id:2,img:require('@/assets/home/news2.jpg'),title:'2023年8月，门店突破2000家',link:null},
                        {id:3,img:require('@/assets/home/news.jpg'),title:'广西玉林仓成立',link:null}
                    ],
                    Stories:[
                        {id:4,img:require('@/assets/home/story2.jpg'),title:'鸣星加盟商专访',link:'https://zymls-os.oss-cn-guangzhou.aliyuncs.com/images/11月2日.mp4_1698896393172'},
                        {id:5,img:require('@/assets/home/story3.jpg'),title:'百万级明星门店的故事',link:'https://zymls-os.oss-cn-guangzhou.aliyuncs.com/video/刘耀雄减速.mp4_1695884324551'},
                        {id:7,img:require('@/assets/home/story1.jpg'),title:'与鸣星老板沉浸式学习',link:'https://zymls-os.oss-cn-guangzhou.aliyuncs.com/video/顶级访谈开头.mp4_1697188714214'},
                    ],
                    Trends:[
                        {id:6,img:require('@/assets/home/brand.jpg'),title:'赵一鸣零食做好食品安全再添新举措，与国际权威检测机构签约在穗举行',link:'https://www.iheima.com/article-362048.html'}
                    ],
                }
                
                ,
                linkOptions:{
                    effect: 'slide',
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    loop:false,
                    autoplay:{
                        disableOnInteraction:false,
                        pauseOnMouseEnter:false
                    },
                },
                urlParam:'',
                playerOptions: {
                    height: "auto",
                    width: "100%",
                    playbackRates: [], // 可选的播放速度
                    autoplay: true, // 如果为true,浏览器准备好时开始回放
                    muted: false, // 默认情况下静音播放
                    loop: false, // 是否视频一结束就重新开始
                    preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据，auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: "zh-CN",
                    aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值，值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小，换句话说，它将按比例缩放以适应其容器
                    sources: [
                    {
                        type: "video/mp4", // 类型
                        src: 'https://zymls-os.oss-cn-guangzhou.aliyuncs.com/images/10月13日.mp4_1699606591493', // url地址，在使用本地的资源时，需要用require()引入，否则控制台会报错
                    },
                    ],
                    poster: require('@/assets/information/banner.png'), // 设置封面地址
                    notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息
                    controlBar: {
                    currentTimeDisplay: true,
                    progressControl: true,  // 是否显示进度条
                    playbackRateMenuButton: true, // 是否显示调整播放倍速按钮
                    timeDivider: false, // 当前时间和持续时间的分隔符
                    durationDisplay: false, // 显示持续时间
                    remainingTimeDisplay: false, // 是否显示剩余时间功能
                    fullscreenToggle: true, // 是否显示全屏按钮
                    },
                },
                dialogVisible:false
            }
        },
        watch:{
            $route(to,from){
                if(to.query.block){
                    this.linkPos();
                }
            }
        },
        computed: {

            swiper() {
                return this.$refs.linkImgRef.swiper;
            }

        },
        created(){
        },
        mounted(){
            this.getLinksData('News');
            // this.getLinksData('News');
            // this.getLinksData('Stories');
            // this.getLinksData('Trends');
            this.linkPos();
            this.watchViewAnimate();
        },
        methods:{
            restartVideo() {
            this.$refs.videoPlayer.currentTime = 0;
            this.$refs.videoPlayer.play();
            },
            watchViewAnimate(){
                const valueListDOMs = [];
                valueListDOMs.push(document.getElementById('count-id'));
                if (!valueListDOMs) return;
                const ob = new IntersectionObserver(entries => {
                    for (const item of entries) {
                        if(item.target.className.indexOf('join-infs') !== -1){
                            if (item.intersectionRatio > 0.1){
                                this.countAnimate();
                            }else{
                                this.resetCount();
                            }
                        }
                    }
                }, {
                    threshold: [.5]
                });
                valueListDOMs.forEach(item => {
                    ob.observe(item)
                })
            },
            toggleLink(arg){
                this.activeLink = arg;
                this.getLinksData(arg);

                if(arg !== 'Dialogue' && arg !== 'Trends'){
                    this.$nextTick(()=>{
                        // this.swiper.slideTo(1,1000,true);
                        // this.swiper.enable();
                        // this.$refs.linkImgRef.swiper.navigation.init();
                    })
                }
            },
            countAnimate(){
                
                const url = this.$WEBSITE_URL_OBJECT.osconfig;
                this.$axios.get(url).then(res=>{
                    const {data} = res.data;
                    if(res.data.code === 0){
                        this.countObj = {
                            successRate:data.successPercent,
                            secondRate:data.secondPercent,
                            storeNum: 20000, // data.storeNum,
                            customerNum:data.customerNum,
                            stuffNum: 5100,// data.stuffNum,
                            skunum: 3300,
                            memberNum: 1.7// data.memberNum
                        }
                    }else{
                        this.countObj = {
                            successRate:95,
                            secondRate:65,
                            storeNum:2200,
                            customerNum:1.5,
                            stuffNum:3000,
                            skunum: 3300,
                            memberNum:1.2
                        }
                    }
                }).catch(()=>{
                    this.countObj = {
                        successRate:95,
                        secondRate:65,
                        storeNum:2200,
                        customerNum:1.5,
                        stuffNum:3000,
                        memberNum:2700
                    }
                }).finally(()=>{

                })
            },
            resetCount(){
                this.countObj = {
                    successRate:0,
                    secondRate:0,
                    storeNum:0,
                    customerNum:0,
                    stuffNum:0,
                    memberNum:0
                }
            },
            changeQy(index){
                this.currActiveQy = index;
            },
            linkPos(){
                const route = this.$route;
                const ref = route.query.block;

                if(ref){
                    const el = this.$refs[ref]
                    el.scrollIntoView(); 
                }
            },
            goDialog(url){

                url ? window.open(url,'_blank') : '';
            },
            openWin(data){
                if(data.newsVideo){
                    this.dialogVisible = true;
                    this.playerOptions.sources[0].src = data.newsVideo;
                }else{
                    data.newsLink ? window.open(data.newsLink,'_blank') : '';
                }
            },
            getLinksData(activeTab){
                let type = 1;
                switch(activeTab){
                    // case 'Dialogue':type = 1;break;
                    case 'News':type = 3;break;
                    case 'Stories':type = 4;break;
                    case 'Trends':type = 2;break;
                }
                const url = this.$WEBSITE_URL_OBJECT.news+'?newsType='+type+'&current=1&size=9999&isHome=1';
                this.$axios.get(url).then(res=>{
                    if(res.data.code === 0 ){
                        this.linkDatas[activeTab] = res.data.data.records;
                        console.log(activeTab, 'activeTab');
                        if(activeTab == 'Dialogue'){
                            this.linkDatas[activeTab].splice(1,1) // 2025 1-2,黄奇 逻辑删除
                        }
                    }else{
                        this.linkDatas[activeTab] = [];
                    }
                }).catch(err=>{
                    this.linkDatas[activeTab] = [];
                }).finally(()=>{
                    console.log(activeTab,this.linkDatas[activeTab])
                })
            },
            closeDialog(){
                this.dialogVisible = false;
            }
        }
    }
</script>
<style scoped src="./index.css"></style>




// WEBPACK FOOTER //
// src/view/home/index.vue